export const SET_DUB_FA = 'SET_DUB_FA';

export const SET_EMAIL = 'SET_EMAIL';
